import React from 'react'
import { dateFormat } from 'helpers/date'
import { classNames } from 'helpers/index'
import Stores from 'Stores'
import st from './InvoiceTicketDetail.module.scss'
import { localisationMaster } from 'Localisation/Localisation'

export default function InvoiceTicketDetail(props) {
  const order = props.order

  const renderStatusDate = () => {
    switch (order.status_order) {
      case 'not_paid':
        return (
          <span>
            {localisationMaster('pay_before', 'pays/invoice')}:{' '}
            {dateFormat(new Date(order.payment_expires), 'dd MMMM YYYY г.')}
          </span>
        )
      case 'paid':
        return (
          <span>
            {localisationMaster('pay-answer', 'pays/payment/answer')}:{' '}
            {dateFormat(new Date(order.payment_date), 'dd MMMM YYYY г.')}
          </span>
        )
      case 'cancelled':
        return (
          <span>
            Отменен: {dateFormat(new Date(order.updated_at), 'dd MMMM YYYY г.')}
          </span>
        )
      default:
        return ''
    }
  }

  return (
    <div className={st.containerHeader}>
      <div
        className={classNames({
          [st.header]: true,
          [st.headerPaid]:
            order.status_order === 'paid' || order.payment_confirmed,
          [st.headerNotPaid]: order.status_order === 'not_paid',
          [st.headerCancelled]: order.status_order === 'cancelled',
        })}
      >
        <div className={st.statusBox}>
          <div className={st.orderStatusBlock}>
            {order.status_text}{' '}
            {order.status_order === 'not_paid' &&
              new Date(order.payment_expires) > new Date() && (
                <>
                  {props.timer < 1 ? (
                    <span
                      className={st.updateStatus}
                      onClick={props.checkOrder}
                    >
                      {localisationMaster('status_1', 'index', 'sidebar_main')}
                    </span>
                  ) : (
                    <span className={'slot_blink notification'}>
                      {localisationMaster(
                        'checking_invoice_status',
                        'pays/invoice',
                      )}
                      ...
                    </span>
                  )}
                </>
              )}
          </div>
          <div className={st.statusDate}>{renderStatusDate()}</div>
        </div>
        <div className={st.summ}>
          {`${Stores.cleanSumm(order.amount / 100)}${localisationMaster('tg', 'groups/group')}`}
        </div>
      </div>
      <div className={st.body}>
        <div className={st.titleAmount}>
          {localisationMaster('purpose_amount_invoice', 'pays/invoice')}
        </div>
        <div className={st.paymentType}>{order.payment_type}:</div>
        <ul className={st.boxTitleAmount}>
          {[
            localisationMaster('table-row-title-6', 'pays/all-pays'),
            localisationMaster('total', 'pays/invoice'),
            localisationMaster('total_payable', 'pays/invoice'),
          ].map((name, idx) => (
            <li key={idx} className={st.amounts}>
              <div className={st.nameTitle}>{name}:</div>
              <div
                className={st.priceTitle}
              >{`${Stores.cleanSumm(order.amount / 100)} ${localisationMaster('tg', 'groups/group')}`}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
